import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=3af83558&scoped=true&"
import script from "./FAQList.vue?vue&type=script&lang=js&"
export * from "./FAQList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af83558",
  null
  
)

export default component.exports